import { UseCase } from '@core/referential/use-case.enum'
import { z } from 'zod'

export const GetUserStateSchemaResponse = z.object({
  currentUseCase: z.nativeEnum(UseCase).nullable(),
  currentSiteId: z.number().nullable(),
})

export type GetUserStateResponse = z.infer<typeof GetUserStateSchemaResponse>
